module.exports = __webpack_public_path__ + "static/media/C20-0053_AW_PBN_Mobile_767x845_Work.3f20d7d0.jpg";